import { __awaiter, __generator } from "tslib";
import getRouteName from './get-route-name';
import { getWebAutoInstrumentations } from '@opentelemetry/auto-instrumentations-web';
import { SpanStatusCode } from '@opentelemetry/api';
var getOperationName = function (_a) {
    var url = _a.url, searchParams = _a.searchParams, body = _a.body;
    var operationName = 'unnamed operation';
    try {
        if (body) {
            var parsedBody = JSON.parse(body);
            operationName = parsedBody.operationName || operationName;
        }
        if (url.includes('operationName')) {
            operationName = searchParams.get('operationName') || operationName;
        }
    }
    catch (e) { }
    return operationName;
};
var webAutoInstrumentations = function (config, routes) {
    var addRouteAttribute = function (name) { return function (span) {
        var routeName = getRouteName(routes);
        span.setAttribute('site.page', routeName);
    }; };
    return getWebAutoInstrumentations({
        '@opentelemetry/instrumentation-document-load': {
            enabled: config.documentLoad,
            applyCustomAttributesOnSpan: {
                documentLoad: addRouteAttribute('documentLoad'),
                documentFetch: addRouteAttribute('documentFetch'),
                resourceFetch: addRouteAttribute('resourceFetch'),
            },
        },
        '@opentelemetry/instrumentation-xml-http-request': {
            enabled: config.fetch,
            propagateTraceHeaderCorsUrls: /.*/,
            clearTimingResources: true,
            ignoreUrls: [/v1\/traces/],
            applyCustomAttributesOnSpan: function (span, xhr) {
                var routeName = getRouteName(routes);
                span.setAttribute('site.page', routeName);
                span.updateName('request xhr');
                if (xhr.status < 200 || xhr.status > 399) {
                    span.setStatus({ code: SpanStatusCode.ERROR, message: xhr.statusText });
                }
            },
        },
        '@opentelemetry/instrumentation-fetch': {
            enabled: config.fetch,
            propagateTraceHeaderCorsUrls: /.*/,
            clearTimingResources: true,
            ignoreUrls: [/_next\/data/],
            applyCustomAttributesOnSpan: function (span, request, response) {
                var _a, _b, _c;
                return __awaiter(this, void 0, void 0, function () {
                    var attributes, routeName, url, _d, pathname, searchParams, contentType, body, isGraphQL, operationName, fetchType, responseBody, _e, error, e_1;
                    return __generator(this, function (_f) {
                        switch (_f.label) {
                            case 0:
                                attributes = span.attributes || {};
                                _f.label = 1;
                            case 1:
                                _f.trys.push([1, 7, , 8]);
                                routeName = getRouteName(routes);
                                span.setAttribute('site.page', routeName);
                                url = attributes['http.url'] || response.url;
                                _d = new URL(url), pathname = _d.pathname, searchParams = _d.searchParams;
                                contentType = (_a = request.headers) === null || _a === void 0 ? void 0 : _a['content-type'];
                                body = request.body;
                                isGraphQL = pathname === '/graphql' && contentType === 'application/json';
                                operationName = isGraphQL
                                    ? getOperationName({
                                        url: url,
                                        body: body,
                                        searchParams: searchParams,
                                    })
                                    : '';
                                fetchType = isGraphQL ? 'graphql' : 'fetch';
                                if (!isGraphQL) return [3 /*break*/, 5];
                                if (!('body' in response)) return [3 /*break*/, 3];
                                return [4 /*yield*/, new Response(response.body).json()];
                            case 2:
                                _e = (_f.sent());
                                return [3 /*break*/, 4];
                            case 3:
                                _e = undefined;
                                _f.label = 4;
                            case 4:
                                responseBody = _e;
                                error = (responseBody === null || responseBody === void 0 ? void 0 : responseBody.error) || ((_b = responseBody === null || responseBody === void 0 ? void 0 : responseBody.errors) === null || _b === void 0 ? void 0 : _b[0]);
                                if (error) {
                                    span.setStatus({ code: SpanStatusCode.ERROR, message: error.message });
                                    span.setAttribute('graphql.error.message', error.message);
                                    if ((_c = error.path) === null || _c === void 0 ? void 0 : _c.length)
                                        span.setAttribute('graphql.error.path', error.path.join(', '));
                                    Object.entries(error.extensions || {}).forEach(function (_a) {
                                        var extension = _a[0], value = _a[1];
                                        span.setAttribute("graphql.error.extensions.".concat(extension), value);
                                    });
                                }
                                return [3 /*break*/, 6];
                            case 5:
                                if ('ok' in response && response.ok === false) {
                                    span.setStatus({ code: SpanStatusCode.ERROR, message: 'failed to fetch' });
                                }
                                _f.label = 6;
                            case 6:
                                span.updateName("request ".concat(fetchType).concat(operationName ? " - ".concat(operationName) : ''));
                                return [3 /*break*/, 8];
                            case 7:
                                e_1 = _f.sent();
                                span.updateName('request fetch');
                                return [3 /*break*/, 8];
                            case 8:
                                span.setAttribute('app.synthetic_request', 'false');
                                return [2 /*return*/];
                        }
                    });
                });
            },
        },
        '@opentelemetry/instrumentation-user-interaction': {
            enabled: (config.userInteraction || []).length > 0,
            eventNames: config.userInteraction || [],
            shouldPreventSpanCreation: function (event, element, span) {
                var _a, _b, _c;
                var routeName = getRouteName(routes);
                span.setAttribute('site.page', routeName);
                var elementId = element.id ||
                    ((_a = element.dataset) === null || _a === void 0 ? void 0 : _a['testid']) ||
                    ((_c = (_b = element.closest('[data-testid]')) === null || _b === void 0 ? void 0 : _b.dataset) === null || _c === void 0 ? void 0 : _c['testid']) ||
                    'unknown';
                span.updateName("interaction ".concat(event, " ").concat(elementId));
                span.setAttribute('interaction.target_id', elementId);
            },
        },
    });
};
export default webAutoInstrumentations;
//# sourceMappingURL=web-auto-instrumentations.js.map